module.exports = {
  modalEventBus: 'question-modal-display',
  selectionTypeSingleSelect: 'single-select',
  selectionTypeMultiSelect: 'multi-select',
  storeNamespace: 'skincareV2Store',
  // Mutation Types
  types: {
    ANSWER: 'answer',
    BACK: 'back',
    CHECK_IF_FINAL: 'checkIfFinal',
    FILTER_ANSWERS: 'filterAnswers',
    FILTER_STEPS: 'filterSteps',
    INIT_QUIZ: 'initQuiz',
    INIT_RESULTS_PAGE: 'initResultsPage',
    NAVIGATE: 'navigate',
    NEXT: 'next',
    REMOVE_ANSWERED_QUESTIONS: 'removeAnsweredQuestions',
    RESET_SELECTIONS: 'resetSelections',
    SEND_NEXT_EVENT: 'sendNextEvent',
    SEND_RESULTS: 'sendResults',
    SET_ACTIVE_QUESTION: 'setActiveQuestion',
    SET_ANSWERS: 'setAnswers',
    SET_ERROR: 'setError',
    SET_LOADING_RESULTS_STATE: 'setLoadingResultsState',
    SET_NEWSLETTER_FORM_DISPLAY: 'setNewsletterFormDisplay',
    SET_QUIZ_CONFIG: 'setQuizConfiguration',
    SET_QUESTIONS: 'setQuestions',
    SET_STEPS: 'setSteps',
    START: 'start',
    UNSELECT_ANSWERS: 'unselectAnswers',
    UPDATE_SINGLE_SELECTION: 'updateSingleSelection',
    UPDATE_MULTI_SELECTION: 'updateMultiSelection',
    UPDATE_NEWSLETTER_FORM_DISPLAY: 'updateNewsletterFormDisplay',
    VALIDATE_DECISION_TREE: 'validateDecisionTree',
    VALIDATE_MIN_OPTIONS_SELECTED: 'validateMinOptionsSelected',
  }
};
